import { render, staticRenderFns } from "./FollowUpPatientStep13Component.vue?vue&type=template&id=224c916e&scoped=true&"
import script from "./FollowUpPatientStep13Component.vue?vue&type=script&lang=js&"
export * from "./FollowUpPatientStep13Component.vue?vue&type=script&lang=js&"
import style0 from "./FollowUpPatientStep13Component.vue?vue&type=style&index=0&id=224c916e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224c916e",
  null
  
)

export default component.exports